import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CustomerDetailModalComponent, CustomerDetailModalContext } from '../../../customer/detail/customer-detail-modal/customer-details-modal.component';
import { MvdModalService } from '../../services/modal/mvd-modal.service';

/**
 * Serves as the context for the customer search view modal dialog
 */
export class CustomerSearchViewContext {
    constructor(
        public searchView: any,
        public includeDeceased: boolean = true) {}
}

/**
    Serves as a dialog to display a customer search
*/
@Component({
    selector: 'customer-search-modal',
    templateUrl: './search-modal.html'
})
export class CustomerSearchViewModalComponent {
    constructor(
        public dialogRef: MatDialogRef<CustomerSearchViewModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: CustomerSearchViewContext,
        public modalService: MvdModalService) {}

    cancel() {
        this.dialogRef.close();
    }

    customerNameClicked(id: number) {
        this.modalService.open(CustomerDetailModalComponent, new CustomerDetailModalContext(id));
    }

    customerSelected(id: number) {
        this.dialogRef.close(id);
    }
}
